import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

var SvgVibration = function SvgVibration(_a) {
  var title = _a.title,
    desc = _a.desc,
    titleId = _a.titleId,
    descId = _a.descId,
    props = __rest(_a, ["title", "desc", "titleId", "descId"]);
  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  props['aria-labelledby'] = ariaLabelledBy;
  return jsxs("svg", __assign({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !!ariaLabelledBy
  }, props, {
    children: [!!title && jsx("title", __assign({
      id: titleId
    }, {
      children: title
    }), void 0), !!desc && jsx("desc", __assign({
      id: descId
    }, {
      children: desc
    }), void 0), jsxs("g", __assign({
      clipPath: "url(#clip0_13_342)"
    }, {
      children: [jsx("path", {
        d: "M3.4 3.20711L2.49286 4.11425L5 6.62139V16.4285C5 17.2142 5.64286 17.8571 6.42857 17.8571H13.5714C14.3 17.8571 14.8929 17.3071 14.9857 16.6071L16.2143 17.8357L17.1214 16.9285L3.4 3.20711ZM6.42857 15V8.04996L13.3786 15H6.42857ZM13.5714 4.99996V11.55L15 12.9785V3.57139C15 2.78568 14.3571 2.14282 13.5714 2.14282H6.42857C5.82143 2.14282 5.3 2.52854 5.09286 3.07139L7.02143 4.99996H13.5714Z",
        fill: "currentColor"
      }, void 0), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.62646 6.75172L3.32824 7.08393C3.22305 7.2011 3.092 7.41859 3.0555 7.6567C3.02278 7.87021 3.06123 8.11228 3.31014 8.35875C3.77992 8.82391 3.8912 9.36019 3.81911 9.83051C3.75252 10.265 3.53391 10.6293 3.34299 10.8478C3.17553 11.0746 3.00594 11.3758 2.9589 11.6527C2.93606 11.7872 2.94532 11.8971 2.98038 11.9871C3.0137 12.0727 3.08279 12.173 3.23764 12.2726L3.28813 12.3051L3.32824 12.3498C3.5225 12.5662 3.7508 12.938 3.81911 13.3837C3.8912 13.8541 3.77992 14.3904 3.31014 14.8555C3.06123 15.102 3.02278 15.3441 3.0555 15.5576C3.092 15.7957 3.22305 16.0132 3.32824 16.1303L3.62646 16.4625L2.96205 17.059L2.66383 16.7268C2.46956 16.5104 2.24127 16.1385 2.17295 15.6928C2.10087 15.2225 2.21215 14.6862 2.68192 14.2211C2.93084 13.9746 2.96928 13.7325 2.93656 13.519C2.90371 13.3047 2.79426 13.1071 2.69602 12.9843C2.43318 12.8011 2.25041 12.573 2.14842 12.3112C2.04077 12.0349 2.03599 11.7544 2.07865 11.5032C2.16164 11.0146 2.43506 10.5709 2.63856 10.2988L2.65051 10.2829L2.66383 10.268C2.76901 10.1508 2.90007 9.93336 2.93656 9.69525C2.96928 9.48174 2.93084 9.23967 2.68192 8.9932C2.21215 8.52804 2.10087 7.99176 2.17295 7.52144C2.24127 7.07571 2.46956 6.70388 2.66383 6.48748L2.96205 6.15527L3.62646 6.75172Z",
        fill: "currentColor"
      }, void 0), jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5521 4.25172L16.8503 4.58393C16.9555 4.7011 17.0866 4.91859 17.1231 5.1567C17.1558 5.37021 17.1173 5.61228 16.8684 5.85875C16.3986 6.32391 16.2874 6.86019 16.3594 7.33051C16.426 7.765 16.6446 8.12928 16.8356 8.34781C17.003 8.57463 17.1726 8.87581 17.2197 9.15271C17.2425 9.28716 17.2332 9.39712 17.1982 9.48714C17.1649 9.57268 17.0958 9.67295 16.9409 9.77262L16.8904 9.80511L16.8503 9.84979C16.6561 10.0662 16.4278 10.438 16.3594 10.8837C16.2874 11.3541 16.3986 11.8904 16.8684 12.3555C17.1173 12.602 17.1558 12.8441 17.1231 13.0576C17.0866 13.2957 16.9555 13.5132 16.8503 13.6303L16.5521 13.9625L17.2165 14.559L17.5147 14.2268C17.709 14.0104 17.9373 13.6385 18.0056 13.1928C18.0777 12.7225 17.9664 12.1862 17.4966 11.7211C17.2477 11.4746 17.2093 11.2325 17.242 11.019C17.2748 10.8047 17.3843 10.6071 17.4825 10.4843C17.7454 10.3011 17.9282 10.073 18.0301 9.81122C18.1378 9.53488 18.1426 9.25435 18.0999 9.00318C18.0169 8.51464 17.7435 8.07086 17.54 7.79883L17.5281 7.78286L17.5147 7.76802C17.4095 7.65085 17.2785 7.43336 17.242 7.19525C17.2093 6.98174 17.2477 6.73967 17.4966 6.4932C17.9664 6.02804 18.0777 5.49176 18.0056 5.02144C17.9373 4.57571 17.709 4.20388 17.5147 3.98748L17.2165 3.65527L16.5521 4.25172Z",
        fill: "currentColor"
      }, void 0)]
    }), void 0), jsx("defs", {
      children: jsx("clipPath", __assign({
        id: "clip0_13_342"
      }, {
        children: jsx("rect", {
          width: 17.1429,
          height: 17.1429,
          fill: "white",
          transform: "translate(1.42856 1.42859)"
        }, void 0)
      }), void 0)
    }, void 0)]
  }), void 0);
};

export { SvgVibration as default };
